import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import 'leaflet/dist/leaflet.css';
import HomePage from '@/pages/HomePage';
import RankingsPage from '@/pages/RankingsPage';
import DestinationPage from '@/pages/DestinationPageNew';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import { Toaster } from '@/components/ui/sonner';
import Disclaimer from '@/pages/Disclaimer';
import PhotoCreditsPage from "@/pages/photo-credits";


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/rankings" element={<RankingsPage />} />
          <Route path="/destination/:id" element={<DestinationPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/photo-credits" element={<PhotoCreditsPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;